import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { analyzeInvoiceOfPaymentRequests } from '@src/api'
import {
  AnalyzeInvoiceOfPaymentRequests200Response,
  DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest,
} from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useAnalyzeInvoiceOfPaymentRequests = (
  onSuccess?: (
    data: AxiosResponse<AnalyzeInvoiceOfPaymentRequests200Response>,
    variables: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest
  ) => void,
  onSettled?: (
    variables: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest
  ) => void
) => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest) =>
      analyzeInvoiceOfPaymentRequests(axiosInstance, params),
    // onSettled(data, error, variables, context) {
    //   onSettled(variables),
    // },
    onSuccess: (
      data: AxiosResponse<AnalyzeInvoiceOfPaymentRequests200Response>,
      variables: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest
    ) => (onSuccess ? onSuccess(data, variables) : undefined),
    onSettled: (
      _data:
        | AxiosResponse<AnalyzeInvoiceOfPaymentRequests200Response>
        | undefined,
      _error: unknown,
      variables: DefaultApiAnalyzeInvoiceOfPaymentRequestsRequest,
      _context: unknown
    ) => (onSettled ? onSettled(variables) : undefined),
  })
}
